// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"ClientWallet_footerContainer__3g22V","savePackageButton":"ClientWallet_savePackageButton__3aqkI"};